<template>
<div class="poster-block">
  <container-grid-size>
    {{blc.blockType}}
  </container-grid-size>
</div>
</template>

<script>
import BlockMixin from "@/Models/blocks/BlockMixin";
import ContainerGridSize from "@/components/atoms/container-grid-size";


export default {
  name: "poster-block",
  components: { ContainerGridSize},
  mixins:[BlockMixin],
  computed:{
    /**
     *
     * @return {PosterBlock}
     */
    blc(){
      return this.block;
    }
  }
}
</script>

<style lang="less">
.poster-block{

}
</style>